import { Component, Input } from '@angular/core';

@Component({

    selector: 'syn-unsafe-link',
    templateUrl: 'unsafe-link.html'
})
export class UnsafeLinkComponent {
    @Input() public href: string;

    constructor(
    ) {
    }

    public isClickableUrl(url: string): boolean {
        return /^https?:\/\//.test(url);
    }

}
